export default __webpack_public_path__ + "static/media/helpscout.d362a1c2.svg";